export default __webpack_public_path__ + "static/media/093-expand-2.63dfb83a.png";